import Bugsnag from '@bugsnag/js';

export default {
  data() {
    return {
      modalOpen: false,
      messageText: '',
      messageVisible: false,
      loader: false
    }
  },
  methods: {
    /**
     * Takes a respons and show customer appropriate message.
     * @param data
     * @param successMessage
     */
    handleResponseMessage(data, successMessage){
      if (data.status === 200) {
        if (successMessage) {
          this.showMessage(successMessage);
        } else {
          this.showMessage();
        }
      } else if (data.errorMessagePretty) {
        Bugsnag.notify(data.errorMessagePretty)
        alert(data.errorMessagePretty);
      } else {
        if (data.errorMessage) {
          console.error(data.errorMessage);
        }
        Bugsnag.notify(data.errorMessage)
        alert("Någonting gick fel. Kontakta supporten om problemet kvarstår.")
      }
    },
    /**
     * Generic fetch call.
     * @param endpoint
     * @param method
     * @param data
     */
    callFasAdApi(endpoint, method, data) {
      console.info("Callfasad runs....");

      // verify session, will reset each 5 min.
      if (window.sessionTimer > 0) {
        fetch(process.env.VUE_APP_API_URL + "/internalapi/auth/test-login")
        .then((response) => {
          window.storeValidateSession(response);
        });
        window.sessionTimer++;
      }

      let options = {
        headers: {
          'Content-Type': 'application/json'
        },
        method: method ? method : "GET",
        credentials: 'include'
      };

      if (data) {
        options.body = JSON.stringify(data);
      }

      return fetch(process.env.VUE_APP_API_URL + endpoint, options)
      .then(r =>  r.json().then(data => ({
        status: r.status,
        data: data.data,
        errorMessage: data.errorMessage,
        errorMessagePretty: data.errorMessagePretty
      })))
    },
    signOut() {
      fetch('/user/logout/', {
        method: 'GET',
        mode: 'no-cors',
        credentials: 'include',
        redirect: 'manual'
      })
      .then(() => {
        this.$store.commit('SET_UNAUTHENTICATED');
        // remove everything stored by persistant state
        localStorage.removeItem('vuex');
        window.location.href = '/login';
      });
    },
    /**
     * Checks if string contains only number
     * @param string
     */
    isNumeric(string) {
      return /^\d+$/.test(string)
    },
    /**
     * Makes pretty numbers
     * @param value 1000000
     * @returns {string} 1 000 000
     */
    formatPrice(value) {
      let val = (value/1).toFixed(0);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
    /**
     * Return the highest number in given array
     * @param array to search
     * @param key to search for highest value
     * @returns {number}
     */
    highestValue(array, key) {
      return Math.max.apply(Math, array.map(function(o) { return o[key]; }))
    },
    /**
     * Generic show message notification
     * @param text
     * @param duration
     */
    showMessage(text = "Uppgifterna sparades!", duration = 2500) {
      this.messageText = text;
      this.messageVisible = true;

      setTimeout(() => {
        this.messageVisible = false;
        this.messageText = "";
      }, duration)
    },
    abortForm() {
      this.modalOpen = false;
      this.$store.commit('STORE_ACTIVE_COMPONENT', null);
    }
  }
};
